import { render } from "./SmSheet.vue?vue&type=template&id=1b5f4dc6&scoped=true"
import script from "./SmSheet.vue?vue&type=script&lang=js"
export * from "./SmSheet.vue?vue&type=script&lang=js"

import "./SmSheet.vue?vue&type=style&index=0&id=1b5f4dc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5f4dc6"]])

export default __exports__